import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AccountInputSearch from "../../../../commons/components/AccountInputSearch";
import AccountSelectOption from "../../../../commons/components/AccountSelectOption";
import AccountButtonAdd from "../../../../commons/components/AccountButtonAdd";

import {
    accessManagementSetSearchPartner,
    accessManagementSetFilterApplication,
    accessManagementSetFilterDepartment,
    accessManagementSetShowUserModal,
    accessManagementSetModeUserModal,
} from "../../../../store/actions/accessManagementActions";

import newUserModalModes from "../NewUserModal/newUserModalModes";
import Http from "../../../../commons/utils/Http";

import { RowFilters, ColFields, ColButtons } from './cardSearchStyles';

function CardSearch(props) {
    const dispatch = useDispatch();
    const { screens } = useSelector(state => state.userLogin);
    const { selectedPartner, searchPartner, filterApplication, filterDepartment } = useSelector(state => state.accessManagement);
    const [permissions] = useState([]);

    const [departments, setDepartments] = useState([]);
    const [applications, setApplications] = useState([]);

    const [searchPartnerValue, setSearchPartnerValue] = useState(searchPartner);

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/gestao-acessos") {
                    screen.functions.map(func => {
                        permissions.push(func)
                    })
                }
            });

            getApplications();
            getDepartments();
        }
    }, [screens]);

    function getApplications() {
        Http.get(`applications/get-total-user-by-partner?id=${selectedPartner.partner_id}`, Http.headers)
            .then(response => {
                const responseData = response.data;
                if (!responseData.response.error) {
                    setApplications(formatSelectApplicationsData(responseData.data));
                }
            }).catch(err => {
                setApplications([]);
            })
    }

    function formatSelectApplicationsData(data) {
        let array = [];
        if (data) {
            data.forEach((dataItem) => {
                let item = {}
                item.label = `${dataItem.application_name}`;
                item.value = dataItem.application_id;
                array.push(item)
            })
        }
        return array;
    }

    function getDepartments() {
        Http.get(`/department/get-all?offset=${0}&order=${"name"}`, Http.headers)
            .then(response => {
                const responseData = response.data;
                if (!responseData.response.error) {
                    setDepartments(formatSelectDepartmentsData(responseData.data));
                }
            }).catch(err => {
                setDepartments([]);
            })
    }

    function formatSelectDepartmentsData(data) {
        let array = [];
        if (data) {
            data.forEach((dataItem) => {
                let item = {}
                item.label = `${dataItem.name}`;
                item.value = dataItem.id;
                array.push(item)
            })
        }
        return array;
    }

    function handleInsertUser() {
        dispatch(accessManagementSetModeUserModal(newUserModalModes.INSERT));
        dispatch(accessManagementSetShowUserModal(true));
    }
    
    function handleOnChangeApplication(value, item) {
        dispatch(accessManagementSetFilterApplication(item ? item : {}));
    }

    function handleOnChangeDepartment(value, item) {
        dispatch(accessManagementSetFilterDepartment(item ? item : {}));
    }

    function handleOnSearchPartner(search) {
        dispatch(accessManagementSetSearchPartner(search));
    }

    function handleOnChangePartner(input) {
        setSearchPartnerValue(input.target.value)
    }

    function renderButtons() {
        return (
            <AccountButtonAdd
                label="Novo usuário"
                onClick={handleInsertUser}
            />
        )
    }

    return (
        <RowFilters>
            <ColFields flex="auto">
                <AccountInputSearch
                    value={searchPartnerValue}
                    placeholder="Pesquisar usuário"
                    style={{ width: 300, marginRight: 6 }}
                    onSearch={handleOnSearchPartner}
                    onChange={handleOnChangePartner}
                />
                <AccountSelectOption
                    value={filterApplication.children}
                    placeholder="Aplicações"
                    style={{ width: 300, marginRight: 6 }}
                    data={applications}
                    onChange={handleOnChangeApplication}
                    allowClear={true}
                    showSearch={true}
                />
                <AccountSelectOption
                    value={filterDepartment.children}
                    placeholder="Setor"
                    style={{ width: 300, marginRight: 6 }}
                    data={departments}
                    showSearch={true}
                    onChange={handleOnChangeDepartment}
                    allowClear={true}
                />
            </ColFields>
            <ColButtons>
                {renderButtons()}
            </ColButtons>
        </RowFilters>
    )
}

export default CardSearch;
